const ButtonMedium = ({ title, disabled, onClick }) => {
  return (
    <button className="btn--text medium" disabled={disabled} onClick={onClick}>
      <span className="btn--text-title hover-underline-animation">{title}</span>
    </button>
  );
};

export default ButtonMedium;
